'use client';

import { useMemo } from 'react';
import type { GameViewModel } from '@/types/games/game-view-model';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { CategoryPlaceholderZone } from '@/app/components/zones/layouts/category-placeholder/category-placeholder-zone';
import { useNewCategory } from '@/app/components/zones/contexts/new-category-context';

type AllNewGamesZoneProps = {
    games: GameViewModel[];
    title?: string;
};

/**
 * "All New Games" list for the New category (i.e. categories that also render a New to
 * You zone). It reuses the shared CategoryPlaceholderZone, but first hides the games
 * currently shown in New to You so a game never appears in both lists. Once a game is
 * launched from New to You it leaves that set and reappears here in its Prismic-defined
 * position.
 *
 * The shown New to You set comes from NewCategoryProvider, the single source of truth
 * shared with the New to You zone.
 */
export const AllNewGamesZone = ({ games, title }: AllNewGamesZoneProps) => {
    const { newToYouUIDs } = useNewCategory();

    const visibleGames = useMemo(() => games.filter((game) => !newToYouUIDs.has(game.uid)), [games, newToYouUIDs]);

    return <CategoryPlaceholderZone games={visibleGames} title={title} />;
};
